import { createApi } from '@reduxjs/toolkit/query/react';
import type { MemberLatestPublishedListingApiResponse } from 'tradera/state/services/types/webapi-member-generated';
import { isomorphicWebApiBaseQuery } from 'tradera/state/services/utils/webapi-base-query';

export const memberLatestPublishedListingApi = createApi({
    reducerPath: 'memberLatestPublishedListing',
    baseQuery: isomorphicWebApiBaseQuery,
    endpoints: (builder) => ({
        getMemberLatestPublishedListing: builder.query<
            MemberLatestPublishedListingApiResponse,
            void
        >({
            query: () =>
                '/api/webapi/member/selling/member-latest-published-listing'
        })
    })
});

export const { useGetMemberLatestPublishedListingQuery } =
    memberLatestPublishedListingApi;
